import { FC } from 'react'
import { absoluteUrl, findPath, storePath } from 'lib/urls'
import { TextLink } from 'baby-design'
import css from '../../global-nav.scss'
import ToggleNav from '../../components/ToggleNav'

interface MinimalSiteNavSectionProps {
  className?: string
  handleToggleNav: () => void
  trackClick: (eventCta: string) => void
  glowupEnabled: boolean
}

const MinimalSiteNavSection: FC<MinimalSiteNavSectionProps> = ({
  trackClick,
  className,
  handleToggleNav,
  glowupEnabled,
}) => (
  <ul className={className}>
    <ToggleNav onClick={handleToggleNav} />
    <li className={css.fullNavOnly}>
      <TextLink
        href={absoluteUrl(storePath)}
        size="md"
        weight="regular"
        onClick={() => trackClick('Shop')}
      >
        {glowupEnabled ? 'Babylist shop' : 'Shop'}
      </TextLink>
    </li>

    <li className={css.fullNavOnly}>
      <TextLink
        href={absoluteUrl(findPath)}
        size="md"
        weight="regular"
        onClick={() => trackClick('Find Registry')}
      >
        {glowupEnabled ? 'Find a registry' : 'Find Registry'}
      </TextLink>
    </li>
  </ul>
)

export default MinimalSiteNavSection
